import React from 'react';
import styles from './CustomerBenefitsWithBadges.module.css';
import { Row, Col } from 'reactstrap';
import { ReactComponent as CustomerSatisFactionSVG } from '../../assets/images/satisfaction.svg';
import { ReactComponent as CompetitiveAdvantageSVG } from '../../assets/images/Vendor/Trane/competitive-advantage.svg';
import { ReactComponent as CustomizePlanSVG } from '../../assets/images/Vendor/Trane/customize-plan.svg';
import { ReactComponent as ExtraRevenuePlanSVG } from '../../assets/images/Vendor/Trane/extra-revenue.svg';

const CustomerBenefitsWithBadges = () => {
    const serviceBenefits = () => {
        const benefits = [
            'Create a Competitive Advantage',
            'Generate Extra Revenue',
            'Customize Plan Offering per Customer',
            'Boost Customer Satisfaction'
        ];
        return benefits.map((benefit, index) => {
            return (
                <Col
                    xs='12'
                    sm='6'
                    md='6'
                    lg='3'
                    key={index}
                >
                    {(index === 0 && <CompetitiveAdvantageSVG />)
                        || (index === 1 && <ExtraRevenuePlanSVG />)
                        || (index === 2 && <CustomizePlanSVG />)
                        || (index === 3 && <CustomerSatisFactionSVG />)}
                    <h4>{benefit}</h4>
                </Col>
            );
        });
    };

    return (
        <Row className={styles.customerBenefitsContainer}>
            <h1>ComfortSure Wants to Help Your Business Thrive</h1>
            <Row className={styles.serviceBenefits}>{serviceBenefits()}</Row>
        </Row>
    );
};

export default CustomerBenefitsWithBadges;
